import PropTypes from 'prop-types';
import './Radio.css';

export default function Radio({
  checked,
  onChange,
  disabled,
  'aria-label': ariaLabel,
}) {
  const cls = ['rd', checked ? 'on' : '', disabled ? 'rd--disabled' : '']
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type="button"
      role="radio"
      aria-checked={checked}
      aria-label={ariaLabel}
      disabled={disabled}
      className={cls}
      onClick={onChange}
      data-testid="radio"
    />
  );
}

Radio.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  'aria-label': PropTypes.string,
};
